import i18n from 'i18next';
import Routes from '../../constants/routes';
import ErrorIcon from '../../images/error-icon.svg';
import SuccessIcon from '../../images/success-icon.svg';
import WarningIcon from '../../images/warning-icon.svg';

export enum ADD_TO_CART_MODAL_TYPES {
    ERROR = 'error',
    INTERACTIVE_SUCCESS = 'interactiveSuccess',
    SUCCESS = 'success',
    WARNING = 'warning'
}

export const getAddToCartModalConfig = (props: { closeModalCB: () => void }) => {
    const { closeModalCB = () => false } = props;
    const isCartPage = window.location.pathname.indexOf(Routes.WARENKORB.path) >= 0;

    const cancelButtonConfig = {
        action: closeModalCB,
        className: ' secondary',
        text: i18n.t('modals:modals.addToCartModal.continue')
    };

    const goToCartButtonConfig = {
        action: () => {
            window.locationReload(Routes.WARENKORB.path);
        },
        className: ' yellow',
        text: i18n.t('modals:modals.addToCartModal.goToCart')
    };

    return {
        [ADD_TO_CART_MODAL_TYPES.SUCCESS]: {
            buttonConfig: isCartPage ? [] : [{ ...cancelButtonConfig }, { ...goToCartButtonConfig }],
            modalBody: () => (
                <div className='text-center tsc-h4 mb-5'>
                    <>
                        <div className='mb-3'>
                            <img alt='' src={SuccessIcon} />
                        </div>
                        {i18n.t('modals:modals.addToCartModal.title')}
                    </>
                </div>
            )
        },
        [ADD_TO_CART_MODAL_TYPES.INTERACTIVE_SUCCESS]: {
            buttonConfig: [{ ...cancelButtonConfig }, { ...goToCartButtonConfig }],
            modalBody: () => (
                <div className='text-center tsc-h4 mb-5'>
                    <>
                        <div className='mb-3'>
                            <img alt='' src={WarningIcon} />
                        </div>
                        {i18n.t('modals:modals.addToCartModal.titleInteractive')}
                    </>
                </div>
            )
        },
        [ADD_TO_CART_MODAL_TYPES.ERROR]: {
            buttonConfig: [],
            modalBody: () => (
                <div className='text-center tsc-h4 mb-5'>
                    <>
                        <div className='mb-3'>
                            <img alt='' src={ErrorIcon} />
                        </div>
                        {i18n.t('modals:modals.addToCartModal.error')}
                    </>
                </div>
            )
        }
    };
};
